import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface AuthUser {
  id: string;
  nickname: string;
  provider: string;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  pendingInviteToken: string | null;
  setAuth: (token: string, user: AuthUser) => void;
  setToken: (token: string) => void;
  setUser: (user: AuthUser) => void;
  setPendingInviteToken: (token: string | null) => void;
  consumePendingInviteToken: () => string | null;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      user: null,
      pendingInviteToken: null,
      setAuth: (token, user) => set({ accessToken: token, user }),
      setToken: (token) => set({ accessToken: token }),
      setUser: (user) => set({ user }),
      setPendingInviteToken: (token) => set({ pendingInviteToken: token }),
      consumePendingInviteToken: () => {
        const current = get().pendingInviteToken;
        if (current) set({ pendingInviteToken: null });
        return current;
      },
      logout: () => set({ accessToken: null, user: null, pendingInviteToken: null }),
    }),
    {
      name: 'fp-auth',
      partialize: (state) => ({
        user: state.user,
        pendingInviteToken: state.pendingInviteToken,
      }),
    },
  ),
);

export function useIsAuthenticated() {
  return useAuthStore((s) => s.accessToken != null);
}
